import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import AmenityVariableAvailability from "./AmenityVariableAvailability";
import PropTypes from "prop-types";
import AvailabilityDateSelector from "../../../../Components/Inputs/Availability/AvailabilityDateSelector";
import AmenityFixedAvailability from "./AmenityFixedAvailability";
import { BookingConfigContext } from "../BookingConfigProvider";

/**
 * Display an availability input for an amenity based on a booking config
 * Could display a fixed or variable control depending on config.
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 * TODO: Fix prop drilling and use more parameters directly from BookingFormProvider
 */
const AmenityAvailability = (props) => {

    const isLoading = useSelector(state => state.module.BOOKINGS.bookingForm.bookingConfigsLoading);

    const {
        unitId,
        bookingDate,
        amenity,
        bookingConfig,
        onBookingDateChange,
        onTimelineBoundaryChange
    } = useContext( BookingConfigContext );

    const availability = bookingConfig?.availability ?? null;

    const [localBookingDate, setLocalBookingDate] = useState(null);

    /**
     * Ensure that the child components do not update until the newly loaded
     * opening hours are retrieved from the new booking config data request
     */
    useEffect(() => {
        setLocalBookingDate(bookingDate);
    }, [bookingDate, availability]);

    if (!amenity || !localBookingDate) {
        return null;
    }

    return <>
        {(props.showBookButton) && (
            <AvailabilityDateSelector
                bookingDate={localBookingDate}
                onBookingDateChange={onBookingDateChange}
                className={(bookingConfig.is_variable !== 1) ? 'margin-bottom-1' : ''}
            />
        )}

        {(bookingConfig.is_variable === 1) &&
            <AmenityVariableAvailability
                unitId={unitId}
                bookingDate={localBookingDate}
                amenityId={amenity.id}
                bookingConfig={bookingConfig}
                maxDuration={bookingConfig.duration}
                availability={availability}

                isEditingExistingBooking={props.isEditingExistingBooking}
                showBookButton={props.showBookButton}
                showNextAvailabilityButton={props.showNextAvailabilityButton}
                isLoading={isLoading}
                allowPast={false}
                startTimeErrorMessages={props.startTimeErrorMessages}

                selectedInterval={props.selectedInterval}

                onChange={props.onChange}
                onError={props.onError}
                onBookingDateChange={onBookingDateChange}
                onTimelineBoundaryChange={onTimelineBoundaryChange}
            />
        }

        {(bookingConfig.is_variable === 0) && <>
            <AmenityFixedAvailability
                unitId={unitId}
                bookingDate={localBookingDate}
                bookingConfig={bookingConfig}
                availability={availability}
                amenity={amenity}

                showNextAvailabilityButton={props.showNextAvailabilityButton}
                useConsecutiveSlots={props.useConsecutiveSlots}

                selectedInterval={props.selectedInterval}

                onChange={props.onChange}
                onBookingDateChange={onBookingDateChange}
            />
        </>}
    </>
}

AmenityAvailability.propTypes = {
    selectedInterval: PropTypes.object,

    onChange: PropTypes.func,
    onError: PropTypes.func,

    useConsecutiveSlots: PropTypes.bool,
    showBookButton: PropTypes.bool,
    showNextAvailabilityButton: PropTypes.bool}

AmenityAvailability.defaultProps = {
    selectedInterval: null,
    useConsecutiveSlots: true,
    showBookButton: false,
    showNextAvailabilityButton: true,
    onError: (error) => {}
}
export default AmenityAvailability;
